var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDotsAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 5.19043C5.50736 5.19043 4.5 6.19779 4.5 7.44043C4.5 8.68307 5.50736 9.69043 6.75 9.69043C7.99264 9.69043 9 8.68307 9 7.44043C9 6.19779 7.99264 5.19043 6.75 5.19043ZM2.5 7.44043C2.5 5.09322 4.40279 3.19043 6.75 3.19043C9.09721 3.19043 11 5.09322 11 7.44043C11 9.78764 9.09721 11.6904 6.75 11.6904C4.40279 11.6904 2.5 9.78764 2.5 7.44043Z",
    fill: "#B4B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 5.19043C16.0074 5.19043 15 6.19779 15 7.44043C15 8.68307 16.0074 9.69043 17.25 9.69043C18.4926 9.69043 19.5 8.68307 19.5 7.44043C19.5 6.19779 18.4926 5.19043 17.25 5.19043ZM13 7.44043C13 5.09322 14.9028 3.19043 17.25 3.19043C19.5972 3.19043 21.5 5.09322 21.5 7.44043C21.5 9.78764 19.5972 11.6904 17.25 11.6904C14.9028 11.6904 13 9.78764 13 7.44043Z",
    fill: "#B4B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 15.6904C5.50736 15.6904 4.5 16.6978 4.5 17.9404C4.5 19.183 5.50736 20.1904 6.75 20.1904C7.99264 20.1904 9 19.183 9 17.9404C9 16.6978 7.99264 15.6904 6.75 15.6904ZM2.5 17.9404C2.5 15.5932 4.40279 13.6904 6.75 13.6904C9.09721 13.6904 11 15.5932 11 17.9404C11 20.2876 9.09721 22.1904 6.75 22.1904C4.40279 22.1904 2.5 20.2876 2.5 17.9404Z",
    fill: "#B4B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 15.6904C16.0074 15.6904 15 16.6978 15 17.9404C15 19.183 16.0074 20.1904 17.25 20.1904C18.4926 20.1904 19.5 19.183 19.5 17.9404C19.5 16.6978 18.4926 15.6904 17.25 15.6904ZM13 17.9404C13 15.5932 14.9028 13.6904 17.25 13.6904C19.5972 13.6904 21.5 15.5932 21.5 17.9404C21.5 20.2876 19.5972 22.1904 17.25 22.1904C14.9028 22.1904 13 20.2876 13 17.9404Z",
    fill: "#B4B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDotsAppIcon);
export default __webpack_public_path__ + "static/media/GrayDotsAppIcon.560ede643a7a5815bb9c59553520c78a.svg";
export { ForwardRef as ReactComponent };